import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { target: String };

  connect() {
    this.update();
    this.timer = setInterval(() => this.update(), 60000);
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  update() {
    const targetTime = new Date(this.targetValue);
    const now = new Date();
    const diff = targetTime - now;

    if (diff <= 0) {
      this.element.textContent = "Auto-approved";
      clearInterval(this.timer);
      return;
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    if (hours > 0) {
      this.element.textContent = `Auto-approves in ${hours}h ${minutes}m`;
    } else {
      this.element.textContent = `Auto-approves in ${minutes}m`;
    }
  }
}
